export const quotes = [
  {
    text: "A vida é aquilo que acontece enquanto você está ocupado fazendo outros planos.",
    author: "John Lennon"
  },
  {
    text: "O futuro pertence àqueles que acreditam na beleza de seus sonhos.",
    author: "Eleanor Roosevelt"
  },
  {
    text: "Só se pode alcançar um grande êxito quando nos mantemos fiéis a nós mesmos.",
    author: "Friedrich Nietzsche"
  },
  {
    text: "A única maneira de fazer um excelente trabalho é amar o que você faz.",
    author: "Steve Jobs"
  },
  {
    text: "A educação é a arma mais poderosa que você pode usar para mudar o mundo.",
    author: "Nelson Mandela"
  },
  {
    text: "Seu tempo é limitado, então não o desperdice vivendo a vida de outra pessoa.",
    author: "Steve Jobs"
  },
  {
    text: "A inspiração existe, mas ela tem que te encontrar trabalhando.",
    author: "Pablo Picasso"
  },
  {
    text: "No meio da dificuldade encontra-se a oportunidade.",
    author: "Albert Einstein"
  },
  {
    text: "O sucesso é ir de fracasso em fracasso sem perder o entusiasmo.",
    author: "Winston Churchill"
  },
  {
    text: "A felicidade não é algo pronto. Ela vem de suas próprias ações.",
    author: "Dalai Lama"
  },
  {
    text: "A vida é 10% o que acontece com você e 90% como você reage a isso.",
    author: "Charles R. Swindoll"
  },
  {
    text: "O melhor momento para plantar uma árvore foi há 20 anos. O segundo melhor momento é agora.",
    author: "Provérbio chinês"
  },
  {
    text: "Não é o mais forte que sobrevive, nem o mais inteligente, mas o que melhor se adapta às mudanças.",
    author: "Charles Darwin"
  },
  {
    text: "A diferença entre o ordinário e o extraordinário é aquele pequeno extra.",
    author: "Jimmy Johnson"
  },
  {
    text: "O fracasso é simplesmente a oportunidade de começar de novo, desta vez de forma mais inteligente.",
    author: "Henry Ford"
  },
  {
    text: "Os limites, como o medo, são frequentemente apenas uma ilusão.",
    author: "Michael Jordan"
  },
  {
    text: "A imaginação é mais importante que o conhecimento.",
    author: "Albert Einstein"
  },
  {
    text: "Viver é a coisa mais rara no mundo. A maioria das pessoas apenas existe.",
    author: "Oscar Wilde"
  },
  {
    text: "Não espere pelo momento perfeito, pegue o momento e torne-o perfeito.",
    author: "Provérbio"
  },
  {
    text: "Você não pode usar a criatividade. Quanto mais você usar, mais você terá.",
    author: "Maya Angelou"
  }
]